<template>
  <div>
    <populate-form
      collapseStyle="simple"
      formTitle="候補管理"
      fkey="wm01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="formDataObj"
      @customValueChanged="optionValueChanged"
    ></populate-form>
    <b-table striped stacked="sm" hover :items="QueryWaitListResult" :fields="fields">
      <template slot="actions" slot-scope="row">
        <b-button size="sm" @click.stop="showDetailPopup(row, row.index, $event.target)" class="mr-1">
          看詳細
        </b-button>
      </template>
    </b-table>
    <b-modal 
      id="detailModal"
      ref="detailModal"
      v-model="modalShow"
      :static="true"
      size="lg"
      centered
      hide-header
      hide-footer
      @hide="closeCheck"
      @shown="setFocus"
    >
      <populate-form
        formTitle="查看候補詳細"
        fkey="vw01"
        ref="popupForm"
        populateOptionVar="popupOptions"
        formDataObjVar="PopupRow"
        :parentVue="this"
      />
    </b-modal>
  </div>
</template>

<script>

export default {
  name: 'WaitlistAdmin',
  components: {

  },
  data: function () {
    return {
      formDataObj: {},
      filterOptions:[
        {
          'componentType':'vue-single-select',
          'optionVar':'Merchants',
          'defaultValue':null,
          'akey':'SelectedMerchantItem',
          'optionLabel':'merchant_name',
          'col':12,
          'placeholder':'篩選供應商',
          'hide':this.$bus.getRole()!=='admin',
        },
        {
          'componentType':'b-form-select',
          'optionVar':'Stores',
          'defaultValue':null,
          'akey':'selectedStore',
          'optionLabel':'store_name',
          'col':4,
          'placeholder':"請選擇分店"
        },
        {
          'componentType':'b-form-select',
          'optionVar':'Services',
          'defaultValue':null,
          'akey':'selectedServiceItem',
          'optionLabel':'service_name',
          'col':8,
          'placeholder':"請選擇課程"
        },
        {
          'componentType':'date-picker',
          'akey':'QueryWaitDate',
          'defaultValue':'',
          'col':3,
          'placeholder':"執行候補動作日期",
          'title':"執行候補動作日期：這是指定只查詢某一天加入的候補,而非候補對象時段的日期",
        },
        {
          'componentType':'date-picker',
          'akey':'QueryWaitPlotStartDate',
          'defaultValue':'',
          'col':3,
          'placeholder':"篩選時段日期起",
          'title':"篩選時段日期起：若指定將只回傳候補對象時段在此日期以後者",
        },
        {
          'componentType':'date-picker',
          'akey':'QueryWaitPlotEndDate',
          'defaultValue':'',
          'col':3,
          'placeholder':"篩選時段日期迄",
          'title':"篩選時段日期迄：若指定將只回傳候補對象時段在此日期以前者",
        },
        {
          'componentType':'text',
          'akey':'QueryMI',
          'defaultValue':'',
          'col':3,
          'placeholder':"會員編號",
          'title':"會員編號：若指定只回傳此會員編號的會員的候補紀錄",
          execCallback:this.GoSearch
        },
        {
          'componentType':'b-form-checkbox',
          'akey':'QueryOutdated',
          'defaultValue':false,
          'col':3,
          'placeholder':"查詢過期的候補紀錄",
          'title':"勾選就只會查詢已過期的失效候補",
        },
        {
          'componentType':'span',
          'akey':'span1',
          'col':7,
        },
        {
          'componentType':'b-button',
          'akey':'button1',
          'col':2,
          'placeholder':"查詢",
          'execCallback':this.GoSearch
        },
      ],
      showFilter: true,
      datePicketOptions: {
        format: 'YYYY/MM/DD',
        useCurrent: false,
      },
      fields: [
        {
          key: 'wait_user_name',
          label: '候補者',
          sortable: false
        },
        {
          key: 'wait_member_id',
          label: '候補者員編',
          sortable: false
        },
        {
          key: 'plot_start_time',
          label: '候補時段',
          sortable: false
        },
        {
          key: 'store_name',
          label: '候補分店',
          sortable: false
        },
        {
          key: 'service_name',
          label: '候補課程',
          sortable: false
        },
        {
          key: 'actions',
          label: '功能'
        }
      ],
      dismissSecs: 1,
      dismissCountDown: 0,
      modalShow: false,
      Merchants: [],
      SelectedMerchantId: null,
      SelectedMerchantItem: Object,
      SelectedMerchant: Object,
      CachedMerchant: Object, //用merchant_id當key的merchant_info cache
      CachedLoginStores: Object, //用merchant_store_id當key的merchant_store login cache
      Stores: [],
      SelectedStoreId: null,
      SelectedStoreAccount: '',
      Services: [],
      SelectedServiceId: null,
      PageNumber: 1,
      ItemsPerPage: 20,
      QueryWaitListResult: [],
      popupOptions:[
        {
          componentType:'span',
          akey:'service_name',
          col:12,
          placeholder:"",
        },
        {
          componentType:'span',
          akey:'span0',
          col:12,
          placeholder:"　", // 換行擠一個空白行需要用全形空白否則會沒高度
        },
        {
          componentType:'span',
          akey:'span1',
          col:3,
          placeholder:"候補者姓名:",
        },
        {
          componentType:'span',
          akey:'wait_user_name',
          col:3,
          placeholder:"",
        },
        {
          componentType:'span',
          akey:'span2',
          col:2,
          placeholder:"候補分店:",
        },
        {
          componentType:'span',
          akey:'store_name',
          col:3,
          placeholder:"",
        },
        {
          componentType:'span',
          akey:'span2-1',
          col:1,
          placeholder:"",
        },
        {
          componentType:'span',
          akey:'span3',
          col:3,
          placeholder:"做候補於:",
        },
        {
          componentType:'span',
          akey:'wait_enqueue_time',
          col:3,
          placeholder:"",
        },
        {
          componentType:'span',
          akey:'span4',
          col:6,
          placeholder:"",
        },
        {
          componentType:'span',
          akey:'span5',
          col:3,
          placeholder:"訂單編號:",
        },
        {
          componentType:'span',
          akey:'bill_id',
          col:3,
          placeholder:"",
        },
        {
          componentType:'span',
          akey:'span6',
          col:2,
          placeholder:"票號:",
        },
        {
          componentType:'span',
          akey:'ticket_no',
          col:3,
          placeholder:"",
        },
        {
          componentType:'span',
          akey:'span6-1',
          col:1,
          placeholder:"",
        },
        {
          componentType:'span',
          akey:'span7',
          col:3,
          placeholder:"候補時間:",
        },
        {
          componentType:'span',
          akey:'plot_start_time',
          col:3,
          placeholder:"",
        },
        {
          componentType:'span',
          akey:'span8',
          col:2,
          placeholder:"預估服務:",
        },
        {
          componentType:'span',
          akey:'service_standard_minutes',
          col:1,
          placeholder:"",
        },
        {
          componentType:'span',
          akey:'span8-1',
          col:1,
          placeholder:"分鐘",
        },
        {
          componentType:'span',
          akey:'span82',
          col:2,
          placeholder:"",
        },
        {
          componentType:'span',
          akey:'span9-0',
          col:12,
          placeholder:"　",
        },
        {
          componentType:'span',
          akey:'span9',
          col:4,
          placeholder:"目標時段當前預約摘要：",
        },
        {
          componentType:'span',
          akey:'plot_reservers',
          col:6,
          placeholder:"",
        },
        {
          componentType:'span',
          akey:'span9-1',
          col:2,
          placeholder:"",
        },
        {
          componentType:'span',
          akey:'span10',
          col:12,
          placeholder:"　",
        },
        {
          componentType:'span',
          akey:'span11',
          col:3,
          placeholder:"看候補手機",
          title:"需先由篩選條件切換到分店才可以查看該分店候補紀錄的手機",
        },
        {
          componentType:'text',
          akey:'SelectedStoreAccount',
          col:3,
          disabled:true,
          placeholder:"請由篩選條件切換",
        },
        {
          componentType:'password',
          akey:'StoreAdminPwd',
          col:3,
          placeholder:"請填店長密碼",
        },
        {
          componentType:'b-button',
          akey:'btnFindTel',
          col:3,
          placeholder:"查候補者手機",
          execCallback:this.LookupWaitTel
        },
        {
          componentType:'span',
          akey:'span12-1',
          col:3,
          placeholder:"",
        },
        {
          componentType:'span',
          akey:'span12-2',
          col:3,
          placeholder:"候補者手機：",
        },
        {
          componentType:'text',
          akey:'WaitUserMobile',
          col:3,
          disabled:true,
          placeholder:"候補者的手機",
        },
        {
          componentType:'span',
          akey:'span12-3',
          col:3,
          placeholder:"",
        },
        {
          componentType:'btn-group',
          akey:'btn-group',
          col:12,
          buttons:[
            {
              akey:"btnclose",
              col:2,
              placeholder: "關閉",
              execCallback: this.closePopup
            }
          ]
        },
      ],
      PopupIndex: 0,
      PopupRow: {},
      StoreAdminPwd: '',
      WaitUserMobile: 'UnKnown'
    }
  },
  props: [

  ],
  methods: {
    LookupWaitTel () {
      if (!this.PopupRow.StoreAdminPwd) {
        this.$refs.popupForm.triggerAlert("店長密碼未填寫無法查詢")
        return
      }
      let Param = {
        'module':'reservation',
        'method':'fetchMobile',
        'role':'merchant',
        'data_type':'ticket_item',
        'data_id':this.PopupRow.wait_user_ticket_item_id,
        'data_fields':'mobile',
        'memberCode':this.PopupRow.StoreAdminPwd
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.PopupRow.WaitUserMobile = data.data.mobile
          vm.$refs.popupForm.refreshModelVar('WaitUserMobile')
          // 如果抓取成功的話,把密碼保存起來
          vm.CachedLoginStores['svs_'+vm.SelectedStoreId].pwd = vm.PopupRow.StoreAdminPwd
      },this)
    },
    optionValueChanged(upd) {
      if (upd.key === 'SelectedMerchantItem') {
        this.SelectedMerchant = upd.val
        this.changeMerchant(upd.val)
      }
      else if (upd.key === 'selectedStore') {
        this.SelectedStoreId = upd.val?upd.val.id:null
        this.changeStore()
      }
      else if (upd.key === 'selectedServiceItem') {
        this.SelectedServiceId = upd.val?upd.val.ticket_project_id:null
      }
    },
    GoSearch () {
      setTimeout(() => {
        this.loadWaitlist()
      }, 200);
    },
    FocusQuery () {
      this.$refs.BtnQuery.focus()
    },
    loadWaitlist () {
      let Param = {
        'module':'admin_manage',
        'method':'getWaitlistBySearch',
        'merchant_id':this.SelectedMerchantId?this.SelectedMerchantId:0,
        'merchant_store_id':this.SelectedStoreId?this.SelectedStoreId:0,
        'ticket_project_id':this.SelectedServiceId?this.SelectedServiceId:0,
        'filter_make_wait_date':this.formDataObj.QueryWaitDate?this.formDataObj.QueryWaitDate:'',
        'filter_wait_plot_start_date':this.formDataObj.QueryWaitPlotStartDate?this.formDataObj.QueryWaitPlotStartDate:'',
        'filter_wait_plot_end_date':this.formDataObj.QueryWaitPlotEndDate?this.formDataObj.QueryWaitPlotEndDate:'',
        'filter_MI':this.formDataObj.QueryMI,
        'outdated':this.formDataObj.QueryOutdated?"1":"0",
        'page_number':this.PageNumber,
        'items_per_page':this.ItemsPerPage,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.QueryWaitListResult = data.data
      },this)
    },
    showDetailPopup: function (row, index) {
      this.PopupRow = this.CpObj(row.item)
      // 補上額外需要的屬性
      this.PopupRow.SelectedStoreAccount = this.SelectedStoreAccount
      this.PopupRow.StoreAdminPwd = this.StoreAdminPwd
      this.$refs.popupForm.setDisabled('btnFindTel',!this.SelectedStoreAccount)
      this.PopupRow.WaitUserMobile = "Unknown"
      //for (let i=0;i<this.popupOptions.length;i++) {
        //if (this.PopupRow.hasOwnProperty(this.popupOptions[i].akey) && this.popupOptions[i].componentType === 'span' ) {
          //this.popupOptions[i].placeholder = this.PopupRow[this.popupOptions[i].akey]+''
        //}
      //}
      // 要呼叫這個才能讓form的顯示與model數據保持一致
      this.$refs.popupForm.refreshModelVar()
      this.PopupIndex = index
      this.WaitUserMobile = 'Unknown'
      this.modalShow = true
    },
    loadMerchants () {
      let Param = {
        'module':'admin_manage',
        'method':'get_merchant_list',
        'merchant_name':'',
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          // eslint-disable-next-line
          vm.Merchants = data.data
      },this)
    },
    changeMerchant(merchant) {
      // eslint-disable-next-line
      if (merchant) {
        this.SelectedMerchantId = merchant.merchant_id
      }
      else {
        this.SelectedMerchantId = null
      }
      setTimeout(() => {
        this.loadMerchantById()
        this.loadWaitlist()
      }, 100);
    },
    changeStore() {
      // 直接呼叫載入選定的商家會失敗...囧
      // 雖然看候補本身不需要登入,但要便利的查候補者手機就需要模擬登入了
      setTimeout(() => {
        this.loadWaitlist()
        this.simulateStoreLogin()
      }, 100);
    },
    loadMerchantById() {
      if (this.SelectedMerchantId === null ) {
        this.Stores = []
        this.SelectedStoreId = null
        this.SelectedStoreAccount = ''
        this.Services = []
        this.SelectedServiceId = null
        this.formDataObj.selectedStore = null
        this.formDataObj.selectedServiceItem = null
        this.$refs.filterForm.refreshModelVar('selectedStore,selectedServiceItem')
        return false
      }
      // 回到預設
      this.Stores = []
      this.SelectedStoreId = null
      this.SelectedStoreAccount = ''
      this.Services = []
      this.SelectedServiceId = null
      this.formDataObj.selectedStore = null
      this.formDataObj.selectedServiceItem = null
      // 先判斷cache
      if (this.CachedMerchant.hasOwnProperty('m_'+this.SelectedMerchantId)) {
        this.Stores = this.CachedMerchant['m_'+this.SelectedMerchantId].merchant_stores
        // 課程目前階段有兩層,需要先處理再產生下拉選單數據
        let services = []
        for (let i=0;i<this.CachedMerchant['m_'+this.SelectedMerchantId].merchant_ticket_projects.length;i++) {
          let item = {
              ticket_project_id:this.CachedMerchant['m_'+this.SelectedMerchantId].merchant_ticket_projects[i].id,
              service_name:this.CachedMerchant['m_'+this.SelectedMerchantId].merchant_ticket_projects[i].ticket_services[0].service_name,
              product_id:this.CachedMerchant['m_'+this.SelectedMerchantId].merchant_ticket_projects[i].product_id
          }
          services.push(item)
        }
        this.Services = this.CpObj(services)
        this.$refs.filterForm.refreshModelVar('selectedStore,selectedServiceItem')
      }
      else {
        // 再抓資料庫放cache
        let Param = {
          'module':'admin_manage',
          'method':'get_merchant_by_id',
          'merchant_id':this.SelectedMerchantId,
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
              vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
              return
            }
            vm.Stores = data.data.merchant_stores
            let services = []
            for (let i=0;i<data.data.merchant_ticket_projects.length;i++) {
              let item = {
                  ticket_project_id:data.data.merchant_ticket_projects[i].id,
                  service_name:data.data.merchant_ticket_projects[i].ticket_services[0].service_name,
                  product_id:data.data.merchant_ticket_projects[i].product_id
              }
              services.push(item)
            }
            vm.Services = vm.CpObj(services)
            vm.$refs.filterForm.refreshModelVar('selectedStore,selectedServiceItem')
            vm.CachedMerchant['m_'+vm.SelectedMerchantId] = data.data
        },this)
      }
    },
    simulateStoreLogin () {
      // 模擬登入(外加cache)
      if (this.SelectedStoreId === null) {
        // 不用清掉當前的模擬商家登入localstorage
        return
      }
      this.StoreAdminPwd = ''
      this.WaitUserMobile = 'Unknown'
      // 先找Cache,若剛剛登入過就重用之前的login session就好
      if (this.CachedLoginStores.hasOwnProperty('svs_'+this.SelectedStoreId)) {
        // 切換merchant_session即可
        const session_key = 'merchant_session'
        window.localStorage.setItem(session_key, JSON.stringify(this.CachedLoginStores['svs_'+this.SelectedStoreId]))
        // 更新選取的分店帳號
        this.SelectedStoreAccount = this.CachedLoginStores['svs_'+this.SelectedStoreId].account
        if (this.CachedLoginStores['svs_'+this.SelectedStoreId].pwd) {
          this.StoreAdminPwd = this.CachedLoginStores['svs_'+this.SelectedStoreId].pwd
        }
      }
      else {
        let Param = {
          'module': 'admin_manage',
          'method': 'simulateMerchantStoreLogin',
          'merchant_store_id': this.SelectedStoreId,
        }
        this.$bus.apiCall(Param, function (data, vm) {
            if (data.ok === 0) {
                vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
                return
              }
            const session_key = 'merchant_session'
            window.localStorage.setItem(session_key, JSON.stringify(data.data))
            vm.CachedLoginStores['svs_'+data.data.merchant_store_id] = data.data
            // 選取的分店店長帳號更新
            vm.SelectedStoreAccount = data.data.account
          },this)
      }
    },
    showCreate () {
      this.modalShow = true
    },
    closePopup () {
      this.modalShow = false
    },
    closeCheck: function () {
      if (this.modalShow) {
        // 需要檢查通過才允許關閉時,上面的判斷改一改,preventDefault後就關不掉了
        // evt.preventDefault()
      }
    },
    setFocus () {

    }
  },
  computed: {
    
  },
  created: function () {
    // 抓api拿merchant
    this.loadMerchants()
  },
  mounted () {
    this.$off('modal-template-create-close')
    this.$on('modal-template-create-close', function () {
      this.modalShow = false
    }.bind(this))
    this.$refs.filterForm.initDefault()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.tooltip-wrapper {
  display: inline-block;
}
.tooltip-wrapper >>> b-button {
  pointer-events: none;
}
.dayplot-container {
  width:100%;
  border-style: inset;
  margin-top:10px;
}
.dayplots-list {
  margin-left:auto;
  margin-right:auto;
  width: 90%;
  height: 400px;
  overflow-y: scroll;
}
.dayplots-list >>> li {
  height:40px;
  margin: 1px;
  background-color: bisque;
}
.time-input-alert {
  width:300px;
  float:right;
}
.filter-container {
  margin:10px;
  border-style: outset;
}
</style>
